import { MigrationManifest, PersistedState } from "redux-persist";

export const migrations: MigrationManifest = {
    0: (state: PersistedState) => {
        return {
            ...state
        };
    }
};
